import store from "@/store";

export default [
  {
    name: "EquipmentProfile",
    path: "/equipment/:id",
    redirect: { name: "EquipmentProfile/Dashboard" }
  },
  {
    name: "EquipmentProfile/EditProfile",
    path: "/equipment/edit-profile/:id",
    beforeEnter: (_to, _from, next) => {
      if (store.getters["auth/equipmentWrite"]) {
        next();
        return;
      } else next({ path: "/error" });
    }
  },
  {
    name: "EquipmentProfile/Dashboard",
    path: "/equipment/:id/dashboard",
    beforeEnter: (_to, _from, next) => {
      if (store.getters["auth/emailVerified"]) {
        next();
        return;
      } else next({ path: "/email-verified" });
    }
  },
  {
    name: "EquipmentProfile/Inspections",
    path: "/equipment/:id/inspections"
  },
  {
    name: "EquipmentProfile/Ranges",
    path: "/equipment/:id/ranges"
  },
  {
    name: "EquipmentProfile/OperationalValues",
    path: "/equipment/:id/operationalValues"
  },
  {
    name: "EquipmentProfile/Charts",
    path: "/equipment/:id/charts"
  },
  {
    name: "EquipmentProfile/ReliabilityList",
    path: "/equipment/:id/reliability"
  },
  {
    name: "EquipmentProfile/RepairLog",
    path: "/equipment/:id/repairlog"
  },
  {
    name: "EquipmentProfile/Planner",
    path: "/equipment/:id/planner"
  },
  {
    name: "EquipmentProfile/Documents",
    path: "/equipment/:id/documents"
  },
  {
    name: "EquipmentProfile/EditOperationalValues",
    path: "/equipment/edit-operational-values/:id",
    beforeEnter: (_to, _from, next) => {
      if (store.getters["auth/equipmentWrite"]) {
        next();
        return;
      } else next({ path: "/error" });
    }
  }
];
